
const digest = 'b41321cc20892a8aefefb5d2bd3c66262dba0295b1c1e015d3ebfc26379d3358';
const classes = {"wrapper":"_wrapper_wxfga_1","list":"_list_wxfga_8","scrollContainer":"_scrollContainer_wxfga_16"};
const css = `._wrapper_wxfga_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: hidden;
  height: calc(100vh - 85px);
}
._wrapper_wxfga_1 ._list_wxfga_8 {
  position: relative;
  background: #ffffff;
  padding: 24px;
  border: 1px solid #eaedf3;
  overflow: hidden;
  height: 100%;
}
._wrapper_wxfga_1 ._list_wxfga_8 ._scrollContainer_wxfga_16 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  